module.exports = __webpack_public_path__ + "static/iyzico-pickbazar-dashboard-bbfbcceb188c7e0a12338ba19c91d1f0.png";